import { Department } from "../department";
import { DocumentTypeKinds } from "./DocumentTypeKinds";
import { IDocumentSource } from "./IDocumentSource";
import { DocumentReference } from "./DocumentReference";

export class DocumentSummary extends DocumentReference {
  // 変数名は暫定
  constructor(
    id: number,
    patientNo: string,
    edition: number,
    previewSource: IDocumentSource,
    printSource: IDocumentSource,
    isPrintable: boolean,
    public documentName: string,
    public formatId: number,
    public patientName: string,
    public department: Department,
    public createdDateTime: Date,
    public createStaffName: string,
    public createTerminal: string,
    public isTemporary: boolean,
    public note: string,
    public isReadable: boolean,
    public isRemovable: boolean,
    public isWritable: boolean,
    public shouldConfirmReadable: boolean,
    public shouldLogin: boolean,
    public shouldWriteAuditLog: boolean,
    public updateDateTime: Date,
    public updateStaffName: string,
    public contentDateTime: Date,
    public reportTypeId: string,
    public reportType: string,
    public published: boolean,
    public publishedDateTime: Date,
    public publishedCount: number,
    public formatOriginalId: number,
    public isDeleted: boolean,
    public firstDocumentDateTime: Date,
    public firstDocumentOperatorName: string,
    public documentType: DocumentTypeKinds,
    public isFixed: boolean,
    public orderUserCode: string,
    public orderUserName: string,
    public attendingUserCode: string,
    public attendingUserName: string,
    public defaultCopies: number,
    public companyName: string,
    public isQuotable: boolean,
    public alternativeFormatOriginalId: number,
    isUnmanaged: boolean,
    public isVirtual: boolean,
  ) {
    super(id, patientNo, edition, previewSource, printSource, isPrintable, defaultCopies, isUnmanaged);
  }
}
